import { useStyleRegister } from '@ant-design/cssinjs';
import { PresetColors } from './interface';
import useToken from './useToken';
import genComponentStyleHook from './util/genComponentStyleHook';
import genPresetColor from './util/genPresetColor';
import statisticToken, { merge as mergeToken } from './util/statistic';
export { DesignTokenContext, defaultConfig } from './context';
export { PresetColors, genComponentStyleHook, genPresetColor, mergeToken, statisticToken, 
// hooks
useStyleRegister, useToken, };
